import React from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

/**
 * Fullscreen control component using Leaflet's native API
 */
const FullscreenControl: React.FC = () => {
  const map = useMap();

  React.useEffect(() => {
    const container = map.getContainer();
    const btn = L.DomUtil.create('div', 'leaflet-bar leaflet-control');
    const link = L.DomUtil.create('a', '', btn);
    link.href = '#';
    link.title = 'Plein écran';
    link.innerHTML = '⛶';
    link.style.fontSize = '18px';
    link.style.lineHeight = '26px';
    link.style.width = '26px';
    link.style.height = '26px';
    link.style.textAlign = 'center';
    link.style.textDecoration = 'none';
    link.style.display = 'block';

    L.DomEvent.on(link, 'click', (e) => {
      L.DomEvent.preventDefault(e);
      if (!document.fullscreenElement) {
        container.requestFullscreen?.();
      } else {
        document.exitFullscreen?.();
      }
    });

    const controlContainer = container.querySelector('.leaflet-top.leaflet-right');
    if (controlContainer) {
      controlContainer.appendChild(btn);
    }

    return () => {
      btn.remove();
    };
  }, [map]);

  return null;
};

export default FullscreenControl;
